import ReactModal from 'react-modal';
import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

const ReactModalAdapter = ({ className, ...props }) => (
  <ReactModal {...props} className="Modal" overlayClassName="Overlay" portalClassName={className} />
);

const PopoverModal = styled(ReactModalAdapter)`
  .Overlay {
  }

  .Modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${themeGet('colors.greys.porcelain')};
  }
`;

PopoverModal.propTypes = {
  ...ReactModal.propTypes,
};

export default PopoverModal;
